{
  "uplift": {
    "header": "Your loan offer through Uplift has expired",
    "nextSteps": "You recently received a loan offer from Uplift, which has now expired. If changes were made to your order details or you think this is an error, please speak to your agent about next steps.",
    "thanks": "If you have already paid using another payment method, we appreciate your interest and hope you’ll consider using Uplift in the future."
  },
  "flexpay": {
    "header": "Your loan offer through Flex Pay has expired",
    "nextSteps": "You recently received a loan offer from Flex Pay, which has now expired. If changes were made to your order details or you think this is an error, please speak to your agent about next steps.",
    "thanks": "If you have already paid using another payment method, we appreciate your interest and hope you’ll consider using Flex Pay in the future."
  }
}
